import React from 'react';
import Slider from '../Slider/Slider';
import TechIcon from './TechIcon';

import './techslider.scss';

import technologyData from '../../data/json/technologies.json';

const TechSlider = () => {
  return (
    <section id="tech-slider" className="container tech-container">
      <Slider>
        {technologyData.map((tech, index) => {
          return (
            <div className="tech-tile" key={index}>
              <h5>{tech.name}</h5>
              <TechIcon icon={tech.icon} />
              <h6>Last used - {tech.lastUsed}</h6>
            </div>
          );
        })}
      </Slider>
    </section>
  );
};

export default TechSlider;



// WEBPACK FOOTER //
// ./src/components/ImageSlider/TechSlider.js